import type { Session } from '@setplex/tria-api'
import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { createStore } from 'effector'

export interface Options {
  bannerCarouselsEnabled?: boolean
  catchupEnabled?: boolean
  chatEnabled?: boolean
  epgEnabled?: boolean
  featuredCarouselsEnabled?: boolean
  inAppSubscriptionManagementEnabled?: boolean
  radioEnabled?: boolean
  tvEnabled?: boolean
  tvShowEnabled?: boolean
  vodEnabled?: boolean
  liveEventEnabled?: boolean
  liveEventRecordsEnabled?: boolean
  movieNightEnabled?: boolean

  // more available options for future use:
  //   backgroundColor?: string | null
  //   backgroundUrl?: string | null
  //   customVideoUrl?: string | null
  //   deviceThemes?: string | null
  //   logoUrl?: string | null
  //   menuTheme?: string | null
  //   screensaver?: number
  //   startPage?: string | null
  //   subTheme?: string | null
  //   themeVideoType?: string | null
}

// options store
export const $optionsFlags = createStore<Options>({})
  .on(api.session.signInFx.doneData, (ops, { payload }) => pick(payload, ops))
  .on(api.session.guestInFx.doneData, (ops, { payload }) => pick(payload, ops))
  .on(api.session.getAccountFx.doneData, (ops, session) => pick(session, ops))
  .reset(api.session.signOutFx.finally)

// options getter
export const get = <K extends keyof Options>(
  name: K,
  def: NonNullable<Options[K]>
): Store<NonNullable<Options[K]>> =>
  $optionsFlags.map((options) => options[name] ?? def)

/**
 * Pick options fields from session
 */
function pick(s: Session | undefined, options: Options): Options {
  if (s == null && typeof s !== 'object') return options
  return {
    ...options,
    bannerCarouselsEnabled: s.bannerCarouselsEnabled,
    catchupEnabled: s.catchupEnabled,
    chatEnabled: s.chatEnabled,
    epgEnabled: s.epgEnabled,
    featuredCarouselsEnabled: s.featuredCarouselsEnabled,
    inAppSubscriptionManagementEnabled: s.inAppSubscriptionManagementEnabled,
    radioEnabled: s.radioEnabled,
    tvEnabled: s.tvEnabled,
    tvShowEnabled: s.tvShowEnabled,
    vodEnabled: s.vodEnabled,
    liveEventEnabled: s.liveEventEnabled,
    liveEventRecordsEnabled: s.liveEventRecordsEnabled,
    movieNightEnabled: s.movieNightEnabled,
  }
}

export const $vodEnabled = get('vodEnabled', false)
export const $tvEnabled = get('tvEnabled', false)
export const $tvShowEnabled = get('tvShowEnabled', false)
export const $bannerCarouselsEnabled = get('bannerCarouselsEnabled', false)
export const $featuredCarouselsEnabled = get('featuredCarouselsEnabled', false)
export const $liveEventEnabled = get('liveEventEnabled', false)
export const $liveEventRecordsEnabled = get('liveEventRecordsEnabled', false)
export const $movieNightEnabled = get('movieNightEnabled', false)
